<template>
  <div class="banner-mid fade-up" v-in-viewport.once>
    <div class="inner" @click="link">
      <picture>
        <source
          :srcset="_.get(getImage, 'devices.mobile')"
          media="(max-width: 769px)"
        />
        <source
          :srcset="_.get(getImage, 'devices.tablet')"
          media="(max-width: 1024px)"
        />
        <img
          :src="_.get(getImage, 'devices.desktop')"
          :alt="_.get(getImage, 'title.title')"
          class="absolute-img"
        />
      </picture>
      <div class="data-cont container">
        <h2 class="title font-55 f-light">
          {{ getTitle }}
        </h2>
        <a v-if="targetBlank" :href="getLink" target="_blank">
          <button class="font-16 f-bold pointer">
            {{ _.get(this.contentData, "data.list.0.url.title") }}
          </button>
        </a>
        <a v-if="!targetBlank" :href="getLink">
          <button class="font-16 f-bold pointer">
            {{ _.get(this.contentData, "data.list.0.url.title") }}
          </button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["contentData"],
  data() {
    return {};
  },
  methods: {
    link() {
      if (window.innerWidth < 1024) {
        this.$router.push(this.getLink);
      }
    }
  },
  computed: {
    getImage() {
      return _.get(this.contentData, "data.list.0.cover_image.0");
    },
    getTitle() {
      return _.get(this.contentData, "data.list.0.title");
    },
    getLink() {
      return _.get(this.contentData, "data.list.0.url.url");
    },
    targetBlank() {
      if (_.get(this.contentData, "data.list.0.url.url_target") == 1) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss">
// @import "../../assets/sass/main.scss";
body.white .banner-mid button {
  text-decoration: underline;
}
body.yellow .banner-mid img,
body.black .banner-mid img {
  filter: brightness(0.3);
}
body.white .banner-mid img {
  filter: brightness(0.6) grayscale(1);
}
.banner-mid {
  &.fade-up.in-viewport {
    opacity: 1;
    transform: translateY(0px);
  }
  .inner {
    position: relative;
    padding-bottom: 610px;
    display: flex;
    justify-content: center;
    @media (max-width: 1679px) {
      padding-bottom: 460px;
    }
    @media (max-width: 1365px) {
      padding-bottom: 377px;
    }
    @media (max-width: 1023px) {
      padding-bottom: 610px;
      justify-content: unset;
    }
    @media (max-width: 767px) {
      padding-bottom: 540px;
    }
    .data-cont {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      @media (max-width: 1365px) {
        width: unset;
      }
      @media (max-width: 1023px) {
        width: unset;
        padding: 0 20px;
      }
      @media (max-width: 835px) {
        top: 98px;
        transform: translateY(0px);
      }
      .title {
        color: var(--white-no-blue);
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        // -webkit-line-clamp: 3;
        @media (max-width: 1365px) {
          font-size: 34px;
        }
        @media (max-width: 767px) {
          -webkit-line-clamp: 8;
        }
        @media (max-width: 374px) {
          font-size: 21px;
        }
      }
      a {
        margin-top: 44px;
        @media (max-width: 1365px) {
          margin-top: 34px;
        }
      }
      button {
        @include defBut(
          var(--white-button-bg),
          var(--bonus-txt2),
          var(--secondarty-transparent),
          var(--white-button-txt)
        );
      }
    }
  }
}
</style>
